import { Component, EventEmitter, HostListener, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';

import { AppState } from 'src/app/store/app.reducer';
import { MtmaModule } from 'src/app/model/mtma-module';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { Observable, Subscription } from 'rxjs';
import { listModuleMtma, LOAD_MODULE, MtmaModuleType, MTMA_MAX_LOAD } from 'src/app/conf/mtma-module';
import { selecMtmaModules } from 'src/app/store/device/device.selector';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
	selector: 'app-mtma-manage-module-add',
	templateUrl: './mtma-manage-module-add.component.html',
})
export class MtmaManageModuleAddComponent implements OnInit, OnDestroy {
	mtmaModules$: Observable<MtmaModule[] | undefined>;
	mtmaModulesSub: Subscription | undefined;

	modulesDefault: MtmaModule[];

	mtmaModules: MtmaModule[] = [];

	mapLoadModule: Map<number, number> = LOAD_MODULE;

	// Design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	DELTA_ERROR_PIXEL = 7;
	MIN_TWO_BUTTONS_DIALOG_WIDTH = 575 + this.DELTA_ERROR_PIXEL;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		this.mtmaModules$ = this.store.select(selecMtmaModules);
	}

	ngOnInit(): void {
		this.modulesDefault = listModuleMtma;
		this.mtmaModulesSub = this.mtmaModules$.subscribe(mtmaModules => {
			this.mtmaModules = mtmaModules;
		});
		this.onResize();
	}

	ngOnDestroy(): void {
		this.mtmaModulesSub?.unsubscribe();
	}

	imageSource(module: MtmaModule): string {
		if (module.Type === MtmaModuleType.MTM8C || module.Type === MtmaModuleType.MTMAC) {
			return 'assets/images/mtma/mtm_black_' + module.Type + '_' + module.Config.Layout + '.svg';
		}
		return 'assets/images/mtma/mtm_black_' + module.Type + '_0.svg';
	}

	addModule(module: MtmaModule) {
		module.Position = this.mtmaModules.length;
		this.store.dispatch(DeviceActions.addMtmaModule({ module }));
	}

	isDisableAdd(module: MtmaModule): boolean {
		let contModule = 0;
		let loadMtma = 0;
		for (const moduleList of this.mtmaModules) {
			loadMtma = loadMtma + this.mapLoadModule.get(moduleList.Type);
			if (moduleList.Type === module.Type) {
				contModule++;
			}
		}
		loadMtma = loadMtma + this.mapLoadModule.get(module.Type);
		if (loadMtma > MTMA_MAX_LOAD) {
			return true;
		}
		if (contModule < module.Max) {
			return false;
		}
		return true;
	}

	closeDialog(): void {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onMobile(): boolean {
		return (this.screenWidth < this.MIN_MD_WIDTH);
	}

	dynamicButtonWidth(): string {
		return (this.screenWidth <= this.MIN_TWO_BUTTONS_DIALOG_WIDTH) ? "w-full" : "w-16rem";
	}
}
